module.exports = __webpack_public_path__ + "img/Knightec.d4abd7d0.png";